export const mainText = "Main";
export const subText = "Sub";
export const yesText = "Yes";
